import React from 'react';
import styled from 'styled-components';

import { getColor } from 'core/utils/Styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const BubbleContainer = styled.div`
	align-self: center;
	border-radius: 0 0 4px 4px;
	transition: all .3s;
	padding: 0 4px 0 4px;
	position: relative;
	z-index: ${({ zIndex }) => zIndex};
	width: calc(100% - 8px);
	margin-top: ${({ suggestionExists }) => suggestionExists ? 0 : '-40px' };
	${({ suggestionExists }) => suggestionExists && `
		background-color: ${getColor('muteBlue')};
		color: ${getColor('darkTeal')};
	`}
	cursor: ${({ suggestionExists }) => suggestionExists ? 'pointer' : 'inherit' };
`;

export const SuggestionText = styled.div`
	font-size: 12px;
	font-weight: 600;
	padding: 12px 0 12px 0;
	text-align: center;
	min-height: 40px;
`;
